import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";
import { MaterialUploadResponse } from "shared";

type UploadVolumetricBaseMaterialsResponse = ClientInferResponseBody<
  typeof contract.materials.uploadVolumetricBaseMaterials,
  200
>;

export const uploadVolumetricBaseMaterials = async (
  file: File,
): Promise<UploadVolumetricBaseMaterialsResponse> => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await api.materials.uploadVolumetricBaseMaterials.mutation({
    body: formData,
  });

  if (response.status === 200) {
    return response.body;
  }

  if (response.status === 400) {
    const errorResponse = response.body as MaterialUploadResponse;
    throw errorResponse;
  }

  throw new ApiError("Failed to import volumetric base materials", response.status, response.body);
};
